import usePagination from '@/hooks/usePagination';
import { UsersFilters } from '@/types/schema';

import { useGroupUsersQuery } from '../graphql/queries/generated/groupUsers';

function useUserGroups({
  filters,
  groupId,
  pause,
}: {
  filters: UsersFilters;
  groupId: string;
  pause: boolean;
}) {
  const { data, error, refetch, fetchMore, isFetching, isFetchingMore, isLoading, totalCount } =
    usePagination(
      useGroupUsersQuery,
      {
        filters,
        groupId,
      },
      {
        edgeKey: 'users',
        pause,
      },
    );

  return {
    isLoading,
    isFetching,
    isFetchingMore,
    error,
    learners: data,
    totalCount,
    refetch,
    fetchMore,
  };
}

export default useUserGroups;
